<template>
<div class="container container--wide">
	<h1>Analysis</h1>
	<hr>
	<div v-if="app.entries.length">
		<h2>Hydrogen Fuelled Per Month</h2>
		<LineChart :chartData="hydrogenFuelled" :options="chartOptionsH"></LineChart>
		<hr>
		<div v-if="app.user.vehicle_model === 'Symbio'">
			<h2>Electricity Charged Per Month</h2>
			<LineChart :chartData="electricityFuelled" :options="chartOptionsE"></LineChart>
			<hr>
		</div>
		<h2>Cost Per Month</h2>
		<line-chart :chartData="cost" :options="chartOptionsC"></line-chart>
		<hr>
		<p style="text-align: center;">
			<router-link :to="{ name: 'History' }" tag="el-button">
				View All Data
			</router-link>
		</p>
	</div>
	<div v-else>
		<h2>You currently don't have any data to analyse.</h2>
		<p>As you start to add entries to this app, we will show you the break down of cost and hydrogen fuelled over the your distance traveled.</p>
		<p>
			<router-link :to="{ name: 'Dashboard' }" tag="el-button">
				Add entry
			</router-link>
		</p>
	</div>
</div>
</template>

<script>
import LineChart from "@/components/analysis/Line";
import BarChart from "@/components/analysis/Bar";
import { REPORT_URL } from "@/config";
import store from "@/utils/store";
import * as auth from "@/utils/auth";
import axios from "axios";
export default {
	name: "analysis",
	data() {
		return {
			app: store
		};
	},
	components: {
		LineChart,
		BarChart
	},
	created() {
		let _self = this;
		axios({
			method: "get",
			url: REPORT_URL,
			headers: {
				Authorization: `Bearer ${auth.getToken()}`
			}
		})
			.then(function(response) {
				auth.setToken(response.headers["x-new-token"]);
				return (_self.app.entries = response.data);
			})
			.catch(function(error) {
				auth.setToken(error.response.headers["x-new-token"]);
				try {
					auth.checkAuth(error);
				} catch (e) {
					return (_self.app.messages = ["Unable to load your data."]);
				}
			});
	},
	computed: {
		distanceDriven() {
			let dd = {
				label: "Distance Driven",
				fill: false,
				borderColor: "#5A7C9F",
				backgroundColor: "#5A7C9F",
				data: [],
				yAxisID: "y-axis-2"
			};
			for (var entry in this.app.entries) {
				dd.data.push(this.app.entries[entry].distance_driven);
			}
			return dd;
		},
		hydrogenFuelled() {
			let chartData = {
				labels: [],
				datasets: []
			};
			let dataset = {
				label: "Hydrogen Fuelled",
				borderColor: "#35495E",
				backgroundColor: "#35495E",
				fill: false,
				data: [],
				yAxisID: "y-axis-1"
			};
			for (var entry in this.app.entries) {
				chartData.labels.push(this.app.entries[entry].label);
				dataset.data.push(
					this.app.entries[entry].hydrogen_fuelled.toFixed(2)
				);
			}
			chartData.datasets.push(dataset, this.distanceDriven);
			return chartData;
		},
		cost() {
			let chartData = {
				labels: [],
				datasets: []
			};
			let dataset = {
				label:
					"Cost (" +
					this.app.loadCurrencySymbol(this.app.user.currency) +
					")",
				borderColor: "#35495E",
				backgroundColor: "#35495E",
				fill: false,
				data: [],
				yAxisID: "y-axis-1"
			};
			for (var entry in this.app.entries) {
				chartData.labels.push(this.app.entries[entry].label);
				dataset.data.push(this.app.entries[entry].cost);
			}
			chartData.datasets.push(dataset, this.distanceDriven);
			return chartData;
		},

		electricityFuelled() {
			let chartData = {
				labels: [],
				datasets: []
			};
			let dataset = {
				label: "Electricity Charged",
				borderColor: "#35495E",
				backgroundColor: "#35495E",
				fill: false,
				data: [],
				yAxisID: "y-axis-1"
			};
			for (var entry in this.app.entries) {
				chartData.labels.push(this.app.entries[entry].label);
				dataset.data.push(
					this.app.entries[entry].electricity_charged.toFixed(2)
				);
			}
			chartData.datasets.push(dataset, this.distanceDriven);
			return chartData;
		},

		chartOptionsH() {
			return {
				responsive: true,
				maintainAspectRatio: false,
				stacked: true,
				scales: {
					xAxes: [
						{
							scaleLabel: {
								display: true,
								labelString: "Date"
							},
							gridLines: {
								drawOnChartArea: true
							}
						}
					],
					yAxes: [
						{
							type: "linear",
							display: true,
							position: "left",
							id: "y-axis-1",
							gridLines: {
								drawOnChartArea: true
							},
							scaleLabel: {
								display: true,
								labelString: "Hydrogen Fuelled (KG)"
							}
						},
						{
							type: "linear",
							display: true,
							position: "right",
							scaleLabel: {
								display: true,
								labelString: this.app.user.units
							},
							id: "y-axis-2"
						}
					]
				}
			};
		},
		chartOptionsE() {
			return {
				responsive: true,
				maintainAspectRatio: false,
				stacked: true,
				scales: {
					xAxes: [
						{
							scaleLabel: {
								display: true,
								labelString: "Date"
							},
							gridLines: {
								drawOnChartArea: true
							}
						}
					],
					yAxes: [
						{
							type: "linear",
							display: true,
							position: "left",
							id: "y-axis-1",
							gridLines: {
								drawOnChartArea: true
							},
							scaleLabel: {
								display: true,
								labelString: "Electricity Charged (kWh)"
							}
						},
						{
							type: "linear",
							display: true,
							position: "right",
							scaleLabel: {
								display: true,
								labelString: this.app.user.units
							},
							id: "y-axis-2"
						}
					]
				}
			};
		},
		chartOptionsC() {
			return {
				responsive: true,
				maintainAspectRatio: false,
				stacked: true,
				scales: {
					xAxes: [
						{
							scaleLabel: {
								display: true,
								labelString: "Date"
							},
							gridLines: {
								drawOnChartArea: true
							}
						}
					],
					yAxes: [
						{
							type: "linear",
							display: true,
							position: "left",
							id: "y-axis-1",
							gridLines: {
								drawOnChartArea: true
							},
							scaleLabel: {
								display: true,
								labelString:
									"Cost (" +
									this.app.loadCurrencySymbol(
										this.app.user.currency
									) +
									")"
							}
						},
						{
							type: "linear",
							display: true,
							position: "right",
							scaleLabel: {
								display: true,
								labelString: this.app.user.units
							},
							id: "y-axis-2"
						}
					]
				}
			};
		}
	}
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// Analysis.vue?5d4d3561